import { render, staticRenderFns } from "./qushi.vue?vue&type=template&id=3a6bf672&scoped=true&"
import script from "./qushi.vue?vue&type=script&lang=js&"
export * from "./qushi.vue?vue&type=script&lang=js&"
import style0 from "./qushi.vue?vue&type=style&index=0&id=3a6bf672&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6bf672",
  null
  
)

export default component.exports